export enum LayoutType {
  Tix = "tix",
  External = "external",
}
